import { AnimatePresence, motion } from 'framer-motion';
import React, { Fragment, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronRight, LayoutDashboard, Menu, X } from 'lucide-react';
import MenuItems from '../../data/MenuItems';
import Logo from '../../assets/images/sire-logo.png';
import { IconMenuDeep } from '@tabler/icons-react';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderText, setHeaderTextIntitial, toggleBar } from '../../redux/reducers/optionsReducers';
import { RouteConstant } from '../../routes/RouteConstant';
import { logout } from '../../redux/reducers/authReducers';

const Sidebar = ({handleToggle}) => {

  const toggle = useSelector((state) => state.options.toggleBar)
  
  const [expand, setExpand] = useState([])

  const MenuItem = MenuItems()

  const menu = () => {
    return(
      <div className='text-white mt-[70px] px-3 mb-4'>
        {
          MenuItem?.map((item, index)=>{
            return(
              <Accordion item={item} expand={expand} setExpand={setExpand} toggle={toggle} />
            )
          })
        }
      </div>
    )
  }

  return (
    <Fragment>
        <div className={`${toggle ? "w-[280px]" : "w-[70px]"} h-full 
        bg-gradient-to-br from-[#1FB6FF] via-[#0070F0] to-[#5A67D8]
        fixed top-0 bottom-0 left-0 max-[1024px]:hidden text-[14px] overflow-x-auto scroll-smooth scrollbar-hide transition-all duration-300 z-50`}>
          <div className={`flex items-center h-[70px] fixed top-0 ${toggle ? "w-[280px] justify-between px-6" : "w-[70px] justify-center"} z-999`}>
            {
              toggle ?
              <>
                <img src={Logo} alt="Logo" className='w-[140px] h-[24px]' />
                <button 
                onClick={handleToggle}
                className="flex items-center justify-center h-9 w-9 rounded-full group hover:bg-gradient-to-br from-indigo-400 via-indigo-500 to-indigo-600 transition-all duration-200"
                >
                  <X size={20} color='white' />
                </button>
              </>:
                <button 
                  onClick={handleToggle} 
                  className="flex items-center justify-center h-9 w-9 rounded-full group hover:bg-gradient-to-br from-indigo-400 via-indigo-500 to-indigo-600 transition-all duration-200"
                >
                  <IconMenuDeep size={20} color='white' />
                </button>
            }
          </div>
          {menu()}
        </div>

        <div className={`hidden ${toggle?"w-[280px] max-[1024px]:block":"hidden"} h-full z-[998] bg-gradient-to-br from-[#1FB6FF] via-[#0070F0] to-[#5A67D8] fixed top-0 overflow-x-auto scroll-smooth scrollbar-hide`}>
          <div className={`flex items-center h-[70px] fixed top-0 ${toggle ? "w-[280px] justify-between px-6" : "w-[70px] justify-center"} z-999`}>
            {
              toggle &&
              <>
                <img src={Logo} alt="Logo" className='w-[140px] h-[24px]' />
                <button 
                onClick={handleToggle}
                className="flex items-center justify-center h-9 w-9 rounded-full group hover:bg-gradient-to-br from-indigo-400 via-indigo-500 to-indigo-600 transition-all duration-200"
                >
                  <X size={20} color='white' />
                </button>
              </>
            }
          </div>
          {menu()}
        </div>

    </Fragment>
  );
};

export default Sidebar;


const Accordion =({item, expand, setExpand})=>{

  const toggle = useSelector((state) => state.options.toggleBar)

  const navigate = useNavigate()

  const activeTab = useLocation().pathname

  const dispatch = useDispatch()

  const handleClick=()=>{
    if(item?.more){
      const expanded = expand.includes(item?.label) 
      ? expand.filter(label => label !== item?.label)
      : [...expand, item?.label];
      setExpand(expanded)
      if(!toggle){
        dispatch(toggleBar())
      }
    }else if(item?.label === "Logout"){
      dispatch(setHeaderTextIntitial());
      dispatch(logout())
      navigate(RouteConstant.ROOT)
    }else{
      dispatch(setHeaderText(item?.label));
      navigate(item?.url)
    }
  }

  const handleSubmenu=(subitem)=>{
    navigate(subitem.url)
    dispatch(setHeaderText(subitem?.label));
  }
  
  const gradientColors = [
    // "bg-gradient-to-br from-emerald-400 via-emerald-500 to-emerald-600",
    // "bg-gradient-to-br from-indigo-400 via-indigo-500 to-indigo-600",
    "text-indigo-500 bg-gradient-to-br from-white via-[#dadef8] to-white",
  ];

  const randomColor = gradientColors[Math.floor(Math.random() * gradientColors.length)]

  return(
    <motion.div 
      className='flex flex-col justify-between w-full items-center cursor-pointer select-none'
      layout
      transition={{ layout: { duration: 0.3, type: "spring" } }}
    >
      <motion.div 
        className={`px-3 py-[12px] flex justify-between w-full items-center rounded-lg 
        ${item?.url === activeTab ? gradientColors[0] : "hover:text-indigo-500 group hover:bg-gradient-to-br hover:from-white hover:via-[#dadef8] hover:to-white"}`} 
        onClick={handleClick}
        whileTap={{ scale: 0.98 }}
        whileHover={{ 
          x: 3,
          transition: { duration: 0.2 } 
        }}
      >
        <div className='flex gap-3'>
          <motion.div
            initial={{ opacity: 0.8 }}
            whileHover={{ 
              opacity: 1,
              scale: 1.1,
              transition: { duration: 0.2 } 
            }}
          >
            {item?.icon}
          </motion.div>
          {
            toggle &&
            <div className='font-medium'>{item.label}</div>
          }
        </div>
        {(item?.more && toggle) && (
          <motion.div
            animate={{ rotate: expand.includes(item?.label) ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <ChevronRight size="20" />
          </motion.div>
        )}
      </motion.div>

      <AnimatePresence initial={false}>
        {(expand.includes(item?.label) && item?.more && toggle) && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ 
              height: "auto", 
              opacity: 1,
              transition: { 
                height: { duration: 0.3 },
                opacity: { duration: 0.3, delay: 0.1 }
              }
            }}
            exit={{ 
              height: 0, 
              opacity: 0,
              transition: { 
                height: { duration: 0.3 },
                opacity: { duration: 0.2 }
              }
            }}
            className='w-full flex flex-col justify-start'
          >
            {item?.more?.map((element, index2) => (
              <motion.div
                key={index2}
                initial={{ x: -10, opacity: 0 }}
                animate={{ 
                  x: 0, 
                  opacity: 1,
                  transition: { delay: index2 * 0.05 }
                }}
                whileHover={{ 
                  x: 5,
                  transition: { duration: 0.2 } 
                }}
                whileTap={{ scale: 0.98 }}
                className={`rounded-lg ml-5 pl-6 py-[12px] flex items-center gap-3
                ${element?.url === activeTab ? gradientColors[0] : "hover:text-blue-600 group hover:bg-gradient-to-br hover:from-white hover:via-[#dadef8] hover:to-white"}`}
                onClick={() => { handleSubmenu(element) }}
              >
                <motion.div
                  whileHover={{ 
                    scale: 1.2,
                    transition: { duration: 0.2 } 
                  }}
                >
                  {element?.icon}
                </motion.div>
                <div className='font-medium'>{element.label}</div>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>

  )
}